import React, { useEffect, useState } from 'react'
import { axiosapi } from '../../api/axiosapi';
import { Link, Outlet } from 'react-router-dom';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const OperatorBookings = (props) => {
    const axiosPrivate = useAxiosPrivate();
    const [booking, setbooking] = useState([])
    useEffect(() => {
        const getBuses = async () => {
            const response = await axiosPrivate.post('/booking/findbyoperator', { userid: props.userid })
            setbooking(response.data.booking)
            console.log(response.data.booking)
        }
        getBuses();

    }, [])
    return (
        <div>
            <p className='text-center text-xl  font-bold mb-6 mt-6'>Bookings</p>
            <div className='flex  gap-2 mb-1 font-semibold mr-10'>
                <p className='w-64'>Booking Id</p>
                <p className='w-64'>Booking Date</p>
                <p className='w-64'>Booking Amount</p>
                <p className='w-64'>Source City</p>
                <p className='w-64'>Destination City</p>

            </div>
            {booking?.map((x) => (
                <Link to={`/operator/booking/${x._id}`} >
                    <div className='flex gap-2 justify-between mb-1  cursor-pointer py-2 border  px-2 mr-10'>
                        <p className='w-64'>{x._id}</p>
                        <p className='w-64'>{x.bookedFor}</p>
                        <p className='w-64'>Rs.{x.amount}</p>
                        <p className='w-64'>{x.routeId.sourceCity}</p>
                        <p className='w-64'>{x.routeId.destinationCity}</p>

                    </div>
                </Link>
            ))}


        </div>
    )
}

export default OperatorBookings